module.exports = {"id":"146536","name":"Jesús Navas","rating":"78","photo":"./data/images/photos/3/146536.png","club":{"name":"Séville FC","logo":"./data/images/clubs/SevilleFC.png"},"positions":["MD","AD","DD","DLD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JesusNavas0.json
// module id = 2010
// module chunks = 0